import { stripeClient } from '@better-auth/stripe/client'
import { magicLinkClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'
import { env } from '@/lib/config/environment'

export const authSocialProviders = ['google', 'microsoft'] as const

export const authClient = createAuthClient({
  baseURL: env.VITE_API_URL,
  plugins: [stripeClient(), magicLinkClient()],
  fetchOptions: {
    credentials: 'include',
  },
})

export const { useSession, signIn, signOut, signUp } = authClient

// Factory function for creating auth client (for testing and flexibility)
export function createAuthClientFactory() {
  return createAuthClient({
    baseURL: env.VITE_API_URL,
    plugins: [stripeClient(), magicLinkClient()],
    fetchOptions: {
      credentials: 'include',
    },
  })
}
